<template>
<section v-if="hasPermissions(['Report Read', 'Report Write'])" class="view">
    <Breadcrumb :breadcrumb="breadcrumb" />
    <h1 class="view__title title--1" v-html="title_page" />
    <div class="view__description">
        <p class="view__description__text">
        </p>
    </div>
    <div class="col-md-12 mb-5">
        <div class="row">
            <FormDynamic 
            :form_format="form_format"
            :form_data="form_data"
            :array_options="array_options"
            content_align_x="22"
            >
                <template v-slot:more-fields>
                    <div class="formdynamic_item col-md-2 py-o">
                        <div class="formdynamic__item__field">
                            <label class="modal-label input-date-template" v-html="`Date Range:`"/>
                            <date-range-picker
                            class="d-block"
                            ref="picker"
                            v-model="form_data.date_range"
                            cancelLabel="Clear">
                                <template v-slot:input="picker" style="min-width: 350px;">
                                    {{ date(picker.startDate) }} - {{ date(picker.endDate) }}
                                </template>

                                <div slot="footer" slot-scope="data" class="slot p-2">
                                    <span class="d-inline-block" style="margin-left: 2px; font-size: 13px; min-width: 7.5rem;">
                                    {{ data.rangeText }}
                                    </span>
                                    <span style="margin-left: auto">
                                        <a @click="clearRangeDate(data)" class="modal__buttons__item cancel">Cancel</a>
                                    </span>
                                    <span style="margin-left: auto">
                                        <a @click="data.clickApply" v-if="!data.in_selection" class="modal__buttons__item" style="width: 4.5rem">Apply</a>
                                    </span>
                                </div>
                            </date-range-picker>
                        </div>
                    </div>
                </template>
            </FormDynamic>
        </div>
        <div class="formdynamic_item col-md-4 py-o">
            <button  class="modal__buttons__item w-auto px-3 ml-0" @click="getReport()">View Report</button>
        </div>
    </div>
    <div v-for="(row, index) in data" :key="row.id">
        <GChart
            v-show="true"
            :ref="`chart_${index}`"
            class="mt-2 gchart-3-invisible"
            type="BarChart"
            :data="row.inspection_items"
            :options="chartOptions"
            :width="2400"
            :height="1440"
            @ready="(chart, google) => onChartReady(chart, google, index)"
        />
    </div>
    <div class="tab-content" v-show="pdfSource">
        <div class="tab-pane fade active show" id="listation">
            <div class="row mb-0 no-gutters justify-content-md-center">
                <div class="col-lg-10" style="min-height: 60rem">
                    <v-card style="height: 100%">
                        <div>
                            <iframe style="width: 100%; height: 60rem;" :src="pdfSource"></iframe>
                        </div>
                    </v-card>
                </div>
            </div>
        </div>
    </div>
    <WaitingModal />
</section>

<div v-else>
    <UnauthorizedComponent :breadcrumb="breadcrumb" />
</div>
</template>

  
  
<script>
import axios from 'axios';
import Resources from './resources'
import FormResources from './form_resources'
import Breadcrumb from '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal from '@/components/WaitingModal'
import UnauthorizedComponent from '@/components/UnauthorizedComponent'
import FormDynamic  from '@/components/FormDynamic.vue'
import { Notyf } from 'notyf'
import 'vuetify/dist/vuetify.min.css'
import 'notyf/notyf.min.css'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import moment from 'moment'
const notyf = new Notyf({
    duration: 8000,
});
import { GChart } from 'vue-google-charts/legacy'

export default {

    name: "RoomTypeByBuildingReport",

    components: {
        Breadcrumb,
        WaitingModal,
        UnauthorizedComponent,
        DateRangePicker,
        FormDynamic,
        GChart
    },

    data() {
        return {
            notyf,
            axios,
            parent_id: 36,
            staffing_scenario_id: this.$route.params.id,
            user: this.get_user(),
            title_page: 'Reports',
            rest_api: `search_standard_reports`,
            title: 'Graph - Inspection Items Grouped by Template',
            current_url: `/reports`,
            table_headers: [],
            array_options: {buildings: []},
            breadcrumb: JSON.parse(JSON.stringify(Resources.breadcrumb)),
            search: '',
            first_request: true,
            pdfSource: '',
            form_format: FormResources.form_format_inspection_items_grouped_by_template,
            form_data:  {date_range: {startDate: "", endDate: ""}, inspection_template_id: []},
            data: [],
            chart_image_uri: [],
            moment
        };
    },

    methods: {

        backToReports() {
            window.location.href = '/reports'
        },

        clearRangeDate(data)
        {
            data.clickCancel()
            this.form_data.date_range = { startDate: null, endDate: null }
        },

        date(val) 
        {
            return val ? moment(val).format("MM/D/YYYY") : "";
        },

        onChartReady(chart, google, index) {
            let that = this;
            google.visualization.events.addListener(chart, 'ready', function () {
                that.chart_image_uri[index] = chart.getImageURI();
            });
        },


        async getReport(print_report = false)
        {
            if(this.form_data.date_range.startDate === null || this.form_data.date_range.endDate === null)
            {
                this.notyf.error('Please select a date range')
                return
            }

            const form_data = {
                standard_report_id: this.parent_id,
                params: {...this.form_data, chart_image_uri: this.chart_image_uri, inspection_template_names: this.data.map(row => row.inspection_template_name), print_report}
            }

            this.loader(true)

            const response = await this.post('search_standard_reports', form_data)

            if (response.status) 
            {
                if(!print_report)
                {
                    this.chart_image_uri = []
                    this.data = response.data.map(row => {
                        let inspection_items = row.inspection_items.map(inspection_item => {
                            return [inspection_item[0], Number(inspection_item[1]), Number(inspection_item[2]), Number(inspection_item[3])];
                        });
                        return {...row, inspection_items};
                    });

                    if(this.data.length > 0)
                    {
                        this.data.forEach(row => {
                            row.inspection_items.unshift(['Inspection Item', 'Pass', 'Fail', 'N/A']);
                        })

                        setTimeout(() => {
                            this.getReport(true)
                        }, 1000);
                    }
                    else
                    {
                        this.notyf.error('No records found for the selected date range')
                        this.pdfSource=  ''
                    }
                }
                else
                {
                    const base64Data = await this.downloadFile(response, true)
                    var blobUrl = URL.createObjectURL(base64Data); 
                    this.pdfSource= blobUrl
                }
            } 
            else 
            {
                this.error_handling(response)
            }

            this.loader(false)
        },
        async getInitialData()
        {
            const form_data = {
                module_id: this.parent_id,
            }

            this.loader(true)

            const response = await this.post('params_standard_reports', form_data)

            if (response.status) 
            {
                this.array_options = response.data
            } 
            else 
            {
                this.error_handling(response)
            }

            this.loader(false)

            return response.data
        },

    },

    computed: {
        
        chartOptions() {
            return {
                legend: { 
                    textStyle: {
                        fontSize: 28,
                    }
                },
                chartArea: { 
                    left: '15%',
                    right: '10%',
                    top: '5%',
                    width: '90%', 
                    height: '100%',
                    bottom: '3%'
                },
                width: 2400,
                height: 1440,
                bar: { groupWidth: "50%" },
                annotations: {
                    alwaysOutside: true,
                    textStyle: {
                        fontSize: 100,
                        bold: true,
                        color: '#000000',
                    },
                    highContrast: false,
                    boxStyle: {
                        stroke: 'transparent',
                        strokeWidth: 0,
                        rx: 0,
                        ry: 0
                    }
                },
                hAxis: {
                    textStyle: {
                        fontSize: 28
                    },
                    format: '0'
                },
                vAxis: {
                    textStyle: {
                        fontSize: 28
                    },
                },
                forceIFrame: false,
                enableInteractivity: true,
                backgroundColor: '#ffffff',
                // Higher quality rendering
                animation: {
                    duration: 0,
                },
            };
        }
    },

    watch: {
    },

    async mounted() 
    {
        if (this.hasPermissions(['Report Read'])) 
        {
            this.getInitialData()

            const today = moment();
            const startDate = today.clone().day(0).format('YYYY-MM-DD') + "T23:00:00.000Z";
            const endDate = today.clone().day(6).format('YYYY-MM-DD') + "T23:59:59.999Z";

            this.form_data.date_range = {startDate: startDate, endDate: endDate}

            this.breadcrumb.push(
                {
                    name: 'Graph - Inspection Items Grouped by Template',
                    href: 'inspection-template-completion-by-room',
                    arrow: '',
                },
            )
        }
    },

}
</script>
<style>
.gchart-3-invisible {
    left: -9999px;
    width: 2400px;
    height: 1440px;
    position: absolute;
    visibility: hidden;
}
</style>
